import * as React from "react";
function SvgLocalisation(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M24 48l-1-1.5c-.6-.9-15.1-21.9-15.1-30.4C7.9 7.2 15.1 0 24 0s16.1 7.2 16.1 16.1c0 8.5-14.5 29.5-15.1 30.4L24 48zm0-45.5c-7.5 0-13.6 6.1-13.6 13.6 0 5.9 9 20.7 13.6 27.5 4.6-6.8 13.6-21.6 13.6-27.5 0-7.5-6.1-13.6-13.6-13.6zm.2 21c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1c0 4-3.2 7.1-7.1 7.1zm0-11.7c-2.6 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6 4.6-2.1 4.6-4.6c.1-2.5-2-4.6-4.6-4.6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLocalisation);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
